import React from "react";
import UserItem from "./UserItem";
import { Grid } from "@material-ui/core";
import Spinner from "../UI/Spinner/Spinner";
const Users = (props) => {
  let usersContainer = props.loading ? (
    <Spinner></Spinner>
  ) : (
    <Grid container spacing={1}>
      {props.users.map((user) => (
        <Grid key={user.id} item xs={12} sm={4} md={3}>
          <UserItem user={user}></UserItem>
        </Grid>
      ))}
    </Grid>
  );
  return usersContainer;
};

export default Users;
